import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { buildUltimosIngresosCurrenciesQuery, GET_ULTIMOS_INGRESOS, UltimosIngresosResponse } from "./graphql";

const useUltimosIngresos = () => {
    const { data, loading, error } = useQuery<UltimosIngresosResponse>(GET_ULTIMOS_INGRESOS, {
        fetchPolicy: "cache-first",
        errorPolicy: "all" // Continue even if there are GraphQL errors
    });

    const items = data?.ultimosIngresos?.items || [];
    // Solo ids numéricos: van interpolados en la query
    const ids = items.map(item => item.id).filter(id => /^\d+$/.test(id));
    const currenciesQuery = useMemo(
        () => (ids.length ? buildUltimosIngresosCurrenciesQuery(ids) : GET_ULTIMOS_INGRESOS),
        [ids.join(",")]
    );
    const { data: currenciesData, loading: currenciesLoading } = useQuery(currenciesQuery, {
        skip: !ids.length,
        fetchPolicy: "cache-first",
        errorPolicy: "all"
    });

    const currencyById = {};
    Object.values(currenciesData || {}).forEach((property: any) => {
        if (property?.id && property?.price?.currency?.name) currencyById[property.id] = property.price.currency;
    });

    return {
        loading: loading || currenciesLoading,
        data: items.map(item => ({ ...item, currency: currencyById[item.id] })),
        error,
        hasProperties: !!items.length
    };
};

export { useUltimosIngresos };
